import { render, staticRenderFns } from "./Caution.vue?vue&type=template&id=303e514f&"
import script from "./Caution.vue?vue&type=script&lang=js&"
export * from "./Caution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports